import { useRouter } from "next/router";
import Link from "next/link";
import PropTypes from "prop-types";
import CmsMenuDropdown from "./CmsMenuDropdown";

export { NavLink };

function NavLink({ link, mobile=false}) {

  if (typeof link != "undefined") {
    if (typeof link.navigation == "undefined" || link.navigation.length == 0) {
      // console.log(link);
      return (
        <Link href={link.path != "" ? link.path : "#"}>
          <a
            className={`${link.active ? "active" : ""}`}
            onClick={() => {
              document.body.classList.remove("mobileMenuOpened")
              document.querySelector('button.burger').classList.remove("menu_open")
              document.querySelector("body, html").classList.remove("no-scroll");
            }}
          >
            {link.name}
          </a>
        </Link>
      );
    } else {
      return <CmsMenuDropdown link={link} mobile={mobile} />
    }
  } else {
    return <></>;
  }
}
